export const Forms = {
  Creators: {audienceName: 'creators', formId: 'fa46da33-ec7d-469a-9d80-803e3535e905'},
  Curators: {audienceName: 'curators', formId: 'd902e131-cfeb-485e-aed2-0601f89426c0'},
  Collectors: {audienceName: 'collectors', formId: '57918b3e-6bd2-4f14-9a5b-bebd38cff7d8'}
}